export default __webpack_public_path__ + "static/media/lucidasansdemibold.4253ce30.ttf";